"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmTerms = void 0;
const react_native_1 = require("react-native");
const react_1 = __importStar(require("react"));
const ConfirmTerms_style_1 = require("./ConfirmTerms.style");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const atome_1 = require("../../atome");
const organisms_1 = require("../../organisms");
const molecules_1 = require("../../molecules");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Terms_service_1 = __importDefault(require("../../../services/Terms.service"));
const enums_1 = require("../../../enums");
// @ts-ignore
function ConfirmTerms({ navigation }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [agbs, setAgbs] = (0, react_1.useState)(false);
    const [privacyPolicy, setPrivacyPolicy] = (0, react_1.useState)(false);
    const [newsletter, setNewsletter] = (0, react_1.useState)(false);
    const [terms, setTerms] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [isModalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [modalContent, setModalContent] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', () => {
            setTimeout(() => {
                if (!auth.isAuthenticated) {
                    navigation.navigate('Login');
                    return;
                }
                getActiveTerms();
                setAgbs(auth.isTermsAgree || false);
                setPrivacyPolicy(auth.isPrivacyPolicyAgree || false);
                setNewsletter(auth.isNewsletterAgree || false);
                if (auth.isTermsAgree && auth.isPrivacyPolicyAgree) {
                    navigation.navigate('Dashboard');
                    return;
                }
                setLoading(false);
            }, 500);
        });
    }, [auth, navigation]);
    const getContent = () => {
        return (react_1.default.createElement("div", { style: { overflowY: 'scroll', overflowX: 'hidden', fontSize: '1.5rem' }, dangerouslySetInnerHTML: { __html: modalContent } }));
    };
    const openModal = (term) => {
        const content = terms.find(t => t.type === term)?.termText || '';
        setModalContent(content);
        setModalVisible(true);
    };
    const closeModal = () => {
        setModalContent('');
        setModalVisible(false);
    };
    const getActiveTerms = async () => {
        Terms_service_1.default.getActiveTerms().then(res => {
            if (res.error) {
                console.log(res);
                return;
            }
            const resTerms = res.data;
            setTerms(resTerms.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()));
        });
    };
    const confirmTerms = async () => {
        const res = await User_service_1.default.confirmTerms({
            terms: auth.isTermsAgree ? false : agbs,
            privacyPolicy: auth.isPrivacyPolicyAgree ? false : privacyPolicy,
            newsletter: auth.isNewsletterAgree ? false : newsletter,
        });
        if (res.error) {
            console.log(res);
            return;
        }
        const newAuth = { ...auth };
        if (!auth.isTermsAgree) {
            newAuth.isTermsAgree = agbs;
        }
        if (!auth.isPrivacyPolicyAgree) {
            newAuth.isPrivacyPolicyAgree = privacyPolicy;
        }
        if (!auth.isNewsletterAgree) {
            newAuth.isNewsletterAgree = newsletter;
        }
        dispatch((0, reducers_1.setAuth)(newAuth));
        if (agbs) {
            await async_storage_1.default.setItem('TermsAgree', 'true');
        }
        if (privacyPolicy) {
            await async_storage_1.default.setItem('PrivacyPolicyAgree', 'true');
        }
        if (newsletter) {
            await async_storage_1.default.setItem('NewsletterAgree', 'true');
        }
        if (agbs && privacyPolicy) {
            navigation.navigate('Dashboard');
        }
    };
    return loading ? (react_1.default.createElement(atome_1.Loading, null)) : (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
        react_1.default.createElement(react_native_1.ScrollView, { style: ConfirmTerms_style_1.styles.scrollView },
            react_1.default.createElement(atome_1.Modal, { modalVisible: isModalVisible, setModalVisible: setModalVisible, cb: closeModal, disableSecondaryButton: true }, getContent()),
            react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: ConfirmTerms_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: [
                        GlobalStyles_1.globalStyles.marginVertical35,
                        GlobalStyles_1.globalStyles.marginHorizontal35,
                    ] },
                    react_1.default.createElement(atome_1.Text, { style: [
                            ConfirmTerms_style_1.styles.heading3,
                            GlobalStyles_1.globalStyles.greenText,
                            GlobalStyles_1.globalStyles.marginTop35,
                        ] }, terms && terms.length > 1 ? terms[0].headline : 'No Headline'),
                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.marginVertical25] }, terms && terms.length > 1 ? terms[0].text : 'No Text'),
                    !auth.isTermsAgree && (react_1.default.createElement(react_native_1.View, { style: [ConfirmTerms_style_1.styles.row, ConfirmTerms_style_1.styles.marginRow, ConfirmTerms_style_1.styles.alignCenter] },
                        react_1.default.createElement(molecules_1.Checkbox, { checked: agbs, label: "", onPress: () => setAgbs(!agbs) }),
                        react_1.default.createElement(atome_1.Label, { style: [ConfirmTerms_style_1.styles.marginBottom15] },
                            "Ich stimme den",
                            ' ',
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.underlined], onPress: () => openModal(enums_1.TERM.TERMS) }, "allgemeinen Gesch\u00E4ftsbedingungen")),
                            ' ',
                            "zu."))),
                    !auth.isPrivacyPolicyAgree && (react_1.default.createElement(react_native_1.View, { style: [ConfirmTerms_style_1.styles.row, ConfirmTerms_style_1.styles.marginRow, ConfirmTerms_style_1.styles.alignCenter] },
                        react_1.default.createElement(molecules_1.Checkbox, { checked: privacyPolicy, label: "", onPress: () => setPrivacyPolicy(!privacyPolicy) }),
                        react_1.default.createElement(atome_1.Label, { style: [ConfirmTerms_style_1.styles.marginBottom15] },
                            "Ich stimme den",
                            ' ',
                            react_1.default.createElement(react_native_1.Pressable, null,
                                react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.underlined], onPress: () => openModal(enums_1.TERM.PRIVACY_POLICY) }, "Angaben zum Datenschutz")),
                            ' ',
                            "zu."))),
                    !auth.isNewsletterAgree && (react_1.default.createElement(react_native_1.View, { style: [ConfirmTerms_style_1.styles.row, ConfirmTerms_style_1.styles.marginRow, ConfirmTerms_style_1.styles.alignCenter] },
                        react_1.default.createElement(molecules_1.Checkbox, { checked: newsletter, label: "", onPress: () => setNewsletter(!newsletter) }),
                        react_1.default.createElement(atome_1.Label, { style: [ConfirmTerms_style_1.styles.marginBottom15] },
                            "Ich m\u00F6chte \u00FCber Neuigkeiten per Newsletter informiert werden.",
                            ' '))),
                    react_1.default.createElement(react_native_1.View, { style: [ConfirmTerms_style_1.styles.row, ConfirmTerms_style_1.styles.marginRow, ConfirmTerms_style_1.styles.buttonContainer] },
                        react_1.default.createElement(react_native_1.Pressable, { style: [
                                ConfirmTerms_style_1.styles.button,
                                (!agbs || !privacyPolicy) && ConfirmTerms_style_1.styles.disabledButton,
                            ], onPress: confirmTerms, disabled: !agbs || !privacyPolicy },
                            react_1.default.createElement(atome_1.Text, { style: [ConfirmTerms_style_1.styles.buttonText] }, "WEITER"))))))));
}
exports.ConfirmTerms = ConfirmTerms;
